import Spec from "../specs/Spec"

export abstract class TaxFormBase {
    public specs: { [key: string]: Spec } = {}

    abstract generateSheets()
    abstract updateDependencies()
    abstract update()
}
